<template>
  <res-select :id="elementId" v-model="selectedBasis" :items="bases" :attach="attachId" :loading="loading" :readonly="readonly" placeholder="All Bases" return-object></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import budgetService from '@/services/budget';

  export default {
    name: 'budgetsAccountingBasisSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        bases: [],
        loading: true
      }
    },
    props: {
      value: {
        required: true
      },
      elementId: {
        type: String,
        default: "budget-accounting-basis-selector"
      },
      readonly: {
        type: Boolean,
        default: false
      },
     triggerLoad: {
        type: Number,
        default: 0
      }
    },
    computed: {
      selectedBasis: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      attachId() {
        return '#' + this.elementId;
      }
    },
    methods: {
      async loadBases() {
        this.loading = true;
        let basesData = await budgetService.getExistingBudgetAccountingBases();
        if (basesData && basesData.data) {
          let ys = [];
          ys.push({ text: "All Bases", value: "" });
          for (var i = 0; i < basesData.data.length; i++) {
            ys.push({ text: basesData.data[i].text, value: basesData.data[i].value });
          }
          this.bases = ys;
        } else {
          let ys = [];
          ys.push({ text: "All Bases", value: "" });
          this.bases = ys;
        }
        this.loading = false;
      },
    },
    watch: {
      triggerLoad: {
        deep: true,
        immediate: true,
        async handler() {
          var self = this;          
            await self.loadBases();
        }
      },
    }
  }
</script>
